import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Check, Clock, MapPin, Flag } from 'lucide-react';
import ConnectorLine from './illustrations/ConnectorLine';
import './BookingStatus.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

const STAGES = [
    { key: 'pending', label: 'Processing' },
    { key: 'assigned', label: 'Confirmed' },
    { key: 'en_route', label: 'Driver On The Way' },
    { key: 'completed', label: 'Completed' },
];

function BookingStatus() {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('t') || '';
    const [booking, setBooking] = useState(null);
    const [error, setError] = useState('');

    const fetchStatus = useCallback(async () => {
        try {
            const response = await axios.get(`${API_URL}/api/status/${id}`, { params: { t: token } });
            setBooking(response.data);
            setError('');
        } catch (err) {
            setError('Booking not found');
        }
    }, [id, token]);

    useEffect(() => {
        fetchStatus();
        const interval = setInterval(fetchStatus, 15000);
        return () => clearInterval(interval);
    }, [fetchStatus]);

    if (error) {
        return (
            <div className="status-page">
                <div className="status-container">
                    <div className="alert alert-error">{error}</div>
                </div>
            </div>
        );
    }

    if (!booking) {
        return (
            <div className="status-page">
                <div className="status-container">
                    <div className="loading">Loading...</div>
                </div>
            </div>
        );
    }

    const currentIndex = STAGES.findIndex((s) => s.key === booking.status);

    return (
        <div className="status-page">
            <div className="status-container">
                <h1>Booking for {booking.customer_name}</h1>
                <p className="status-subtitle">
                    <MapPin size={16} /> {booking.pickup_location} <Flag size={16} /> {booking.destination}
                </p>
                <p className="status-time"><Clock size={14} /> {new Date(booking.pickup_datetime).toLocaleString()}</p>

                <div className="status-steps-wrap">
                    <ConnectorLine orientation="vertical" className="status-connector" />
                    <div className="status-steps">
                        {STAGES.map((stage, index) => (
                            <div
                                key={stage.key}
                                className={`status-step ${index <= currentIndex ? 'done' : ''} ${index === currentIndex ? 'current' : ''}`}
                            >
                                <div className="status-dot">
                                    {index <= currentIndex && <Check size={14} />}
                                </div>
                                <span>{stage.label}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {booking.status === 'cancelled' && (
                    <div className="alert alert-error" style={{ marginTop: '20px' }}>
                        This booking was cancelled.
                    </div>
                )}
            </div>
        </div>
    );
}

export default BookingStatus;